<template>
  <div class="exam-detail-page">
    <Mytitle />
    <div class="page-header">
      <h3>考试详情</h3>
      <button class="btn-back" @click="goBack">返回</button>
    </div>
    <div class="content" v-if="detail">
      <h2 class="title">{{ detail.title || detail.name }}</h2>
      <div class="grid">
        <div><strong>考试时间：</strong>{{ detail.ticket_time_text || (detail.start_time || detail.end_time ? formatRange(detail.start_time, detail.end_time) : '待定') }}</div>
        <div><strong>报名时间：</strong>{{ formatRange(detail.enroll_start_time, detail.enroll_end_time) }}</div>
        <div><strong>报名费：</strong>{{ formatFee(detail.fee) }}</div>
        <div v-if="positionSchedules && positionSchedules.length > 0" class="position-schedules">
          <strong>报考岗位及考试时间：</strong>
          <div v-for="(schedule, index) in positionSchedules" :key="index" class="position-schedule-item">
            <div class="position-name">{{ schedule.position || '未分配岗位' }}</div>
            <div v-if="schedule.subjects && schedule.subjects.length > 0" class="subjects-list">
              <div v-for="(subject, idx) in schedule.subjects" :key="idx" class="subject-item">
                <span class="subject-name">{{ subject.name || '考试' }}</span>
                <span class="subject-time">{{ formatSubjectTime(subject) }}</span>
              </div>
            </div>
            <div v-else class="no-schedule">暂未安排考试时间</div>
          </div>
        </div>
        <div v-else-if="detail.positions && detail.positions.length > 0">
          <strong>可报考职位：</strong>
          <span v-for="(position, index) in detail.positions" :key="index" class="position-tag">
            {{ position }}
          </span>
        </div>
      </div>
      <div v-if="descHtml" class="desc" v-html="descHtml"></div>
    </div>
    <div class="empty" v-else>正在加载考试详情...</div>
  </div>
</template>

<script>
import Mytitle from "../assets/title.vue"
import { getExamDetail, getExam } from "../api/exams"
export default {
  name: 'ExamDetailPage',
  components: { Mytitle },
  props: { id: { type: [String, Number], default: '' } },
  data() { return { detail: null } },
  async mounted() {
    await this.fetch()
  },
  methods: {
    async fetch() {
      try {
        const d = await (getExamDetail ? getExamDetail(this.id) : getExam(this.id))
        this.detail = d || null
      } catch (e) { this.detail = null }
    },
    formatRange(s, e) {
      const fmt = (d) => {
        if (!d) return '-'
        const dt = new Date(d)
        if (isNaN(dt)) return d
        const Y = dt.getFullYear(); const M = String(dt.getMonth()+1).padStart(2,'0'); const D = String(dt.getDate()).padStart(2,'0');
        const h = String(dt.getHours()).padStart(2,'0'); const m = String(dt.getMinutes()).padStart(2,'0')
        return `${Y}-${M}-${D} ${h}:${m}`
      }
      return `${fmt(s)} - ${fmt(e)}`
    },
    formatFee(v) { const n = Number(v ?? 0); return Number.isNaN(n) ? '¥0.00' : '¥' + n.toFixed(2) },
    goBack() {
      try {
        const arr = JSON.parse(localStorage.getItem('app_history') || '[]')
        const prev = arr.pop()
        localStorage.setItem('app_history', JSON.stringify(arr))
        if (prev && prev.hash) {
          if (prev.hash === '#home') {
            try {
              if (prev.nav) localStorage.setItem('redirect_home_nav', prev.nav)
              if (prev.subNav) localStorage.setItem('redirect_home_subnav', prev.subNav)
            } catch (_) {}
            window.location.hash = 'home'
            return
          }
          window.location.hash = prev.hash.replace(/^#?/, '#')
          return
        }
      } catch (_) {}
      window.location.hash = 'home'
    }
  },
  computed: {
    descHtml() {
      const d = this.detail
      const html = d?.content_html || d?.description || ''
      return typeof html === 'string' ? html : ''
    },
    positionSchedules() {
      if (!this.detail) return []
      
      // 解析 ticket_subjects 数据
      let subjectsArray = null
      try {
        const raw = this.detail.ticket_subjects
        subjectsArray = typeof raw === 'string' ? JSON.parse(raw) : raw
      } catch (e) {
        console.warn('解析 ticket_subjects 失败', e)
      }
      
      if (!subjectsArray || !Array.isArray(subjectsArray)) return []
      
      const positions = this.detail.positions || []
      const schedules = []
      
      // 按岗位分组科目
      const positionMap = new Map()
      
      subjectsArray.forEach(subject => {
        const pos = subject.position || ''
        if (!positionMap.has(pos)) {
          positionMap.set(pos, [])
        }
        positionMap.get(pos).push(subject)
      })
      
      // 如果有岗位列表，按岗位顺序生成
      if (positions.length > 0) {
        positions.forEach(position => {
          const subjects = positionMap.get(position) || positionMap.get('') || []
          schedules.push({
            position: position,
            subjects: subjects
          })
        })
      } else {
        // 没有岗位列表，显示所有科目
        positionMap.forEach((subjects, position) => {
          schedules.push({
            position: position || '通用',
            subjects: subjects
          })
        })
      }
      
      return schedules
    }
  },
  methods: {
    formatSubjectTime(subject) {
      if (!subject) return ''
      
      const period = subject.time_period || ''
      const start = subject.start_time || ''
      const end = subject.end_time || ''
      
      if (period && start && end) {
        return `${period} ${start}-${end}`
      } else if (start && end) {
        return `${start}-${end}`
      } else if (period) {
        return period
      }
      
      return '时间待定'
    },
    async fetch() {
      try {
        const d = await (getExamDetail ? getExamDetail(this.id) : getExam(this.id))
        this.detail = d || null
      } catch (e) { this.detail = null }
    },
    formatRange(s, e) {
      const fmt = (d) => {
        if (!d) return '-'
        const dt = new Date(d)
        if (isNaN(dt)) return d
        const Y = dt.getFullYear(); const M = String(dt.getMonth()+1).padStart(2,'0'); const D = String(dt.getDate()).padStart(2,'0');
        const h = String(dt.getHours()).padStart(2,'0'); const m = String(dt.getMinutes()).padStart(2,'0')
        return `${Y}-${M}-${D} ${h}:${m}`
      }
      return `${fmt(s)} - ${fmt(e)}`
    },
    formatFee(v) { const n = Number(v ?? 0); return Number.isNaN(n) ? '¥0.00' : '¥' + n.toFixed(2) },
    goBack() {
      try {
        const arr = JSON.parse(localStorage.getItem('app_history') || '[]')
        const prev = arr.pop()
        localStorage.setItem('app_history', JSON.stringify(arr))
        if (prev && prev.hash) {
          if (prev.hash === '#home') {
            try {
              if (prev.nav) localStorage.setItem('redirect_home_nav', prev.nav)
              if (prev.subNav) localStorage.setItem('redirect_home_subnav', prev.subNav)
            } catch (_) {}
            window.location.hash = 'home'
            return
          }
          window.location.hash = prev.hash.replace(/^#?/, '#')
          return
        }
      } catch (_) {}
      window.location.hash = 'home'
    }
  }
}
</script>

<style scoped>
.exam-detail-page { padding: 16px; max-width: 980px; margin: 0 auto; }
.page-header { display: flex; align-items: center; gap: 16px; margin-bottom: 12px; }
.btn-back { margin-left: auto; background: #f0f0f0; border: 1px solid var(--color-border); border-radius: var(--radius-sm); padding: 6px 12px; cursor: pointer; }
.content { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-md); padding: var(--space-4); }
.title { margin: 0 0 12px; }
.grid { display: grid; grid-template-columns: 1fr; gap: 8px; }
.position-tag { display: inline-block; background: var(--color-primary-light); color: var(--color-primary); padding: 2px 8px; border-radius: var(--radius-sm); margin-right: 8px; margin-bottom: 4px; }

/* 岗位考试时间样式 */
.position-schedules { grid-column: 1 / -1; }
.position-schedule-item { 
  margin-top: 12px; 
  padding: 12px; 
  background: #f8f9fa; 
  border-radius: 6px; 
  border-left: 3px solid #409eff;
}
.position-schedule-item:first-child { margin-top: 8px; }
.position-name { 
  font-weight: 600; 
  color: #303133; 
  margin-bottom: 8px;
  font-size: 15px;
}
.subjects-list { 
  display: flex; 
  flex-direction: column; 
  gap: 6px; 
}
.subject-item { 
  display: flex; 
  align-items: center; 
  gap: 8px;
  padding: 6px 10px;
  background: white;
  border-radius: 4px;
  font-size: 14px;
}
.subject-name { 
  font-weight: 500; 
  color: #606266;
  min-width: 60px;
}
.subject-time { 
  color: #909399;
}
.no-schedule { 
  color: #909399; 
  font-size: 14px;
  font-style: italic;
}

.desc { margin-top: 12px; background: var(--color-surface); }
.desc :deep(p) { margin: 0.6em 0; }
.desc :deep(h1), .desc :deep(h2), .desc :deep(h3) { margin: 0.8em 0 0.5em; }
.empty { color: var(--color-text-secondary); }
</style>
